import React, { useState } from 'react';
import greaterThanIcon from '../../assets/icons/greaterthan.png';
import { Tooltip } from 'react-tooltip';
import { truncateText } from '../../utils/utilFun.js';
import ViceversaArrow from '../../components/ViceversaArrow.jsx';
import Popup from '../../components/Popup.jsx';
import Preview from '../../components/preview/index.jsx';
import { managerLevelId } from '../../utils/Constant.js';

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

const expendetHeaderCSS =
  'flex smAndMd:flex-row  smAndMd:items-center flex-col lg:grow lg:items-center justify-between text-secondary-400 text-xs font-medium';

const expenedParagraphSecondCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] smAndMd:w-full smAndMd:text-left smAndMd:justify-end lg:flex justify-center items-center';

const expendedSemiHeaderCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] lg:flex justify-center items-center lg:bg-[#EEEEEE] smAndMd:w-full w-full smAndMd:text-left lg:text-center';

const ApprovalDetails = ({
  details,
  expandedRow,
  userDetails,
  handleRowClick,
  handleClick,
  handleApprovalAndRemarkChange,
  handleCalculationChange,
  data
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  return (
    <div className="mt-7">
      <Preview
        show={previewUrl}
        url={previewUrl}
        onClose={() => {
          setPreviewUrl(null);
        }}
      />

      <div className={`grid ${Number(managerLevelId) === Number(data[0]?.level_id) ? "grid-cols-9" : "grid-cols-8" } bg-[#EEEEEE] item-center flex-wrap rounded-t-md p-4 font-semibold text-xs text-center text-gray-700 smAndMd:hidden`}>
        <div className="col-span-1 text-[#514D4C]">Activity Date</div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          From & To City
        </div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Fare(₹)
        </div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Hotel Bills
        </div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Fare Bills
        </div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Other Bill
        </div>
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Tada Exp(₹)
        </div>
       {Number(managerLevelId) === Number(data[0]?.level_id) ?  <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Tada Exp(₹)Adj
        </div> : null}
        <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
          Status
        </div>
      </div>

      <div className="bg-white rounded-b-md border border-t-0 border-gray-300 smAndMd:hidden">
        {Array.isArray(details) &&
          details.length > 0 &&
          details.map((item, index) => (
            <div key={index}>
              <div className={`grid ${Number(managerLevelId) === Number(data[0]?.level_id) ? "grid-cols-9" : "grid-cols-8" } items-center gap-2 text-xs text-center font-medium text-[#514D4C] p-3`}>
                {/* Activity Date column: toggle icon + clickable date */}
                <div className="col-span-1 flex items-center justify-center gap-1">
                  <img
                    src={greaterThanIcon}
                    className={`cursor-pointer w-5 h-5 transform transition-transform ${expandedRow === index ? 'rotate-90' : ''}`}
                    alt="toggle"
                    onClick={() => handleRowClick(index)}
                    data-tooltip-id="expand"
                    data-tooltip-content={expandedRow === index ? '' : 'Expand'}
                  />
                  <span
                    data-tooltip-id="navigate"
                    data-tooltip-content="Navigate to Expense Details"
                    className="text-[10px] truncate text-primary cursor-pointer hover:underline"
                    onClick={() => handleClick(item)}
                  >
                    {formatDate(item.date)}
                  </span>
                  <Tooltip id="navigate" className="!text-xs font-normal" />
                </div>
                {/* From & To City */}
                <div className="col-span-1 px-2 text-[10px] truncate min-w-0">
                  {item.fromTown}-{item.toTown}
                </div>
                {/* <div className="col-span-1 -ml-40">{item.toTown}</div> */}
                <div className="col-span-1 px-2 truncate min-w-0">
                  <span></span> {item.fare}
                </div>
                <div className="col-span-1 px-2 truncate min-w-0">
                  {/* <span>₹</span> {item.totalSubmitted} */}
                  {item?.uploadTypeDto.length > 0 ? (
                    item?.uploadTypeDto?.map((fare) => {
                      return (
                        <div>
                          {fare?.billTypeCode === 'HB' ? (
                            <div
                              className="underline text-[#A04D95] cursor-pointer"
                              onClick={() => {
                                setPreviewUrl(fare?.fileUrl);
                              }}
                            >
                              View
                            </div>
                          ) : null}
                        </div>
                      );
                    })
                  ) : (
                    <div>{'-'}</div>
                  )}
                </div>

                <div className="col-span-1 flex flex-col items-center justify-center">
                  {item?.uploadTypeDto.length > 0 ? (
                    item?.uploadTypeDto?.map((fare) => {
                      return (
                        <div>
                          {fare?.billTypeCode === 'FB' ? (
                            <div
                              className="underline text-[#A04D95] cursor-pointer"
                              onClick={() => {
                                setPreviewUrl(fare?.fileUrl);
                              }}
                            >
                              View
                            </div>
                          ) : null}
                        </div>
                      );
                    })
                  ) : (
                    <div>{'-'}</div>
                  )}
                </div>
                <div className="col-span-1 flex flex-col items-center justify-center">
                  {item?.uploadTypeDto.length > 0 ? (
                    item?.uploadTypeDto?.map((fare) => {
                      return (
                        <div>
                          {fare?.billTypeCode === 'OB' ? (
                            <div
                              className="underline text-[#A04D95] cursor-pointer"
                              onClick={() => {
                                setPreviewUrl(fare?.fileUrl);
                              }}
                            >
                              View
                            </div>
                          ) : null}
                        </div>
                      );
                    })
                  ) : (
                    <div>{'-'}</div>
                  )}
                </div>
                <div className="col-span-1 flex flex-col items-center justify-center">
                  {item?.tadaTotal}
                </div>
                {Number(managerLevelId) === Number(data[0]?.level_id) ? <div className="col-span-1 flex flex-col items-center justify-center">
                  <input
                    type="text"
                    className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                    value={item?.staticTadaTotal ?? ''}
                    onChange={(e) => {
                      handleCalculationChange(
                        index,
                        'staticTadaTotal',
                        e?.target?.value
                      );
                    }}
                    name="staticTadaTotal"
                  />
                </div> : null}
                <div className="col-span-1 flex flex-col items-start justify-center pl-2">
                  <label className="flex items-center space-x-1 cursor-pointer text-xs">
                    <input
                      className="accent-primary cursor-pointer"
                      type="radio"
                      value="A"
                      checked={
                        userDetails[item.expenseDetailId]?.status === 'A' ||
                        !userDetails[item.expenseDetailId]?.status
                      }
                      onChange={(e) =>
                        handleApprovalAndRemarkChange(
                          e,
                          item.expenseDetailId,
                          'status'
                        )
                      }
                      defaultChecked
                    />
                    <span>Approve</span>
                  </label>
                  <label className="flex items-center space-x-1 mt-2 cursor-pointer text-xs">
                    <input
                      className="accent-primary cursor-pointer"
                      type="radio"
                      value="R"
                      checked={
                        userDetails[item.expenseDetailId]?.status === 'R'
                      }
                      onChange={(e) =>
                        handleApprovalAndRemarkChange(
                          e,
                          item.expenseDetailId,
                          'status'
                        )
                      }
                    />
                    <span>Reject</span>
                  </label>
                </div>
              </div>

              {index < details.length - 1 && (
                <hr className="border-t border-gray-300 " />
              )}

              {/* Expanded Row */}
              {expandedRow === index && (
                <div className=" bg-gray-100 p-3 -mb-2">
                  <div className={`grid ${Number(managerLevelId) === Number(data[0]?.level_id) ? "grid-cols-8" : "grid-cols-7" } text-[10px] items-center text-center font-semibold text-gray-700`}>
                    <div className="col-span-1 ">Activity</div>
                    <div className="col-span-1 ">Category</div>
                    <div className="col-span-1 ">Mode</div>
                    {/* <div className="col-span-1 ">Way</div> */}
                    <div className="col-span-1 ">Distance(km)</div>
                    <div className="col-span-1 ">Allowance(₹)</div>
                    <div className="col-span-1 whitespace-nowrap">
                      Other Expense Total(₹)
                    </div>
                    {Number(managerLevelId) === Number(data[0]?.level_id) ? <div className="col-span-1">Other Expense Total(₹)Adj</div> : null}
                    <div className="col-span-1  whitespace-nowrap">
                      Approver Remarks
                    </div>
                  </div>
                  <div className="w-full h-[0.5px] mt-2 mb-2 bg-line-color"></div>
                  <div className={`grid ${Number(managerLevelId) === Number(data[0]?.level_id) ? "grid-cols-8" : "grid-cols-7" } py-2 text-xs text-center font-medium rounded-t-md text-[#514D4C]`}>
                    <div
                      className="col-span-1 flex font-semibold text-primary justify-center"
                      onClick={() =>
                        item.activity === 'Field Work' && handleOpenPopup(item)
                      }
                    >
                      <span
                        className={
                          item.activity === 'Field Work'
                            ? ' text-primary  pr-1 cursor-pointer'
                            : ' text-black '
                        }
                      >
                        {item.activity}
                      </span>
                      <span
                        data-tooltip-id="popup"
                        data-tooltip-content="View more details"
                      >
                        {item.activity === 'Field Work' && (
                          <Popup color="#A04D95" />
                        )}
                        <Tooltip id="popup" className="!text-xs font-normal" />
                      </span>
                    </div>
                    <div className="col-span-1 ">{item.stationType}</div>
                    <div className="col-span-1 ">{item.modeEntered}</div>
                    {/* <div className="col-span-1 pr-10">{item.wayEntered}</div> */}
                    <div className="col-span-1 ">
                      {item.distance} <span>KM</span>
                    </div>
                    <div className="col-span-1 ">
                      <span></span> {item.allownace}
                    </div>

                    <div className="col-span-1 ">

                      {item?.otherExpenseTotal}
                    </div>

                    {Number(managerLevelId) === Number(data[0]?.level_id)? <div className="col-span-1 ">
                      <input
                        type="text"
                        className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                        value={item?.staticOtherExpenseTotal ?? ''}
                        onChange={(e) => {
                          handleCalculationChange(
                            index,
                            'staticOtherExpenseTotal',
                            e?.target?.value
                          );
                        }}
                        name="otherExpense"
                      />
                    </div> : null}
                    <div className="col-span-1 ">


                      <textarea
                        className="border-gray-300 border-[0.5px] rounded-md p-1 text-xs h-10 w-full focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                        name="remark"
                        value={
                          userDetails[item.expenseDetailId]?.remark === 's'
                            ? ''
                            : userDetails[item.expenseDetailId]?.remark || ''
                        }
                        onChange={(e) =>
                          handleApprovalAndRemarkChange(
                            e,
                            item.expenseDetailId,
                            'remark'
                          )
                        }
                      />
                    </div>
                  </div>
                  {/* */}
                </div>
              )}
            </div>
          ))}

        {/* Final Total For Desktop Device */}
        <div className="lg:flex lg:flex-row lg:border-b-[1px]  lg:border-l-[1px]  lg:border-r-[1px] lg:border-t-[1px] lg:border-line-color rounded-md   lg:cursor-pointer mx-4 mt-4 m-4">
          {[
            {
              label: 'Metro Charge',
              value: Array.isArray(details) && details[0]?.metroCharge,
            },
            ( Number(managerLevelId) === Number(data[0]?.level_id) && {
              label: 'Metro Charge Adj',
              value: (
                <input
                  type="text"
                  className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                  value={
                    (Array.isArray(details) && details[0]?.staticMetroCharge) ??
                    ''
                  }
                  onChange={(e) => {
                    handleCalculationChange(
                      0,
                      'staticMetroCharge',
                      e?.target?.value
                    );
                  }}
                  name="metroCharges"
                />
              ),
            }),
            {
              label: 'Courier/Photo Copy',
              value: Array.isArray(details) && details[0]?.photoCopy,
            },
            (Number(managerLevelId) === Number(data[0]?.level_id) && {
              label: 'Courier/Photo Copy Adj',
              value: (
                <input
                  type="text"
                  className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                  value={
                    (Array.isArray(details) && details[0]?.staticPhotoCopy) ??
                    ''
                  }
                  onChange={(e) => {
                    handleCalculationChange(
                      0,
                      'staticPhotoCopy',
                      e?.target?.value
                    );
                  }}
                  name="photoCharges"
                />
              ),
            }),
            {
              label: 'Local Conveyance',
              value: Array.isArray(details) && details[0]?.localConveyance,
            },
            ( Number(managerLevelId) === Number(data[0]?.level_id) && {
              label: 'Local Conveyance Adj',
              value: (
                <input
                  type="text"
                  className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                  value={
                    (Array.isArray(details) && details[0]?.staticLocalConveyance) ??
                    ''
                  }
                  onChange={(e) => {
                    handleCalculationChange(
                      0,
                      'staticLocalConveyance',
                      e?.target?.value
                    );
                  }}
                  name="localConveyance"
                />
              ),
            }),
            {
              label: 'Fare',
              value:
                Array.isArray(details) &&
                details?.reduce((a, c) => {
                  return a + c?.fare;
                }, 0),
            },
            {
              label: 'Allowance',
              value:
                Array.isArray(details) &&
                details?.reduce((a, c) => {
                  return a + c?.allownace;
                }, 0),
            },
            {
              label: 'Tada Exp',
              value:
                Array.isArray(details) &&
                details?.reduce((a, c) => a + (c?.staticTadaTotal ?? 0), 0),
            },
          ].filter(Boolean).map((item, index) => {
            const isBorderNeeded =
              index < 4 ? 'md:border-r-[1.5px] lg:border-[#B3B3B3]' : '';
            return (
              <div key={index} className={expendetHeaderCSS}>
                <div className={expendedSemiHeaderCSS}>
                  <p
                    className={`smAndMd:grow smAndMd:border-r-2 smAndMd:border-white lg:grow ${isBorderNeeded} font-medium text-[#514D4C]`}
                  >
                    {item.label}
                  </p>
                </div>
                <div className={expenedParagraphSecondCSS}>₹{item.value}</div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row justify-evenly items-start sm:items-center bg-[#F7F0FF] rounded-md mx-4 mt-4 p-4 gap-3 sm:gap-0 divide-y divide-[#E0D9F0] sm:divide-y-0 m-4">
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0 first:pt-0">
            <div className="text-[#514D4C] font-medium">Expense Total</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce((a, c) => a + (c?.staticTadaTotal ?? 0), 0)}
            </div>
          </div>
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Other Expense</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) => a + (c?.staticOtherExpenseTotal ?? 0),
                  0
                )}
            </div>
          </div>
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Grand Total</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) =>
                    a + (c?.tadaTotal ?? 0) + (c?.otherExpenseTotal ?? 0),
                  0
                ) +
                  Number(details[0]?.metroCharge) +
                  Number(details[0]?.photoCopy) +
                  Number(details[0]?.localConveyance)}
            </div>
          </div>
          {Number(managerLevelId) === Number(data[0]?.level_id) ? <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Grand Total Adj</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) =>
                    a +
                    (c?.staticTadaTotal ?? 0) +
                    (c?.staticOtherExpenseTotal ?? 0),
                  0
                ) +
                  Number(details[0]?.staticMetroCharge) +
                  Number(details[0]?.staticPhotoCopy)}
            </div>
          </div> : null}
        </div>
      </div>

      {/* Table Body for Mobile device */}
      <div className="bg-white flex-wrap rounded-b-md border text-center border-t-0 -mt-6 border-gray-300  lg:hidden overflow-x-scroll ">
        {Array.isArray(details) &&
          details.length > 0 &&
          details.map((item, index) => (
            <div key={index}>
              <div className="block pb-1 lg:hidden">
                <div className="w-full flex justify-between items-center">
                  <div className="flex items-center gap-4 mt-1 ml-2">
                    <p
                      className="text-primary underline text-baseSm font-semibold"
                      onClick={() => handleClick(item)}
                    >
                      {formatDate(item.date)}
                    </p>
                  </div>
                  <div
                    className="flex items-center gap-4 mt-1 -mb-1"
                    onClick={() =>
                      item.activity === 'Field Work' && handleOpenPopup(item)
                    }
                  >
                    <span
                      className={
                        item.activity === 'Field Work'
                          ? 'cursor-pointer text-baseSm font-medium text-primary  -mr-2'
                          : 'text-baseSm font-medium'
                      }
                    >
                      {item.activity}
                    </span>
                    {/* {item.activity === 'Field Work' && (
                      <Popup color="#A04D95" className="-ml-9" />
                    )} */}
                  </div>
                  <p className="text-primary text-baseSm mr-2 font-semibold">
                    {item.distance}KM
                  </p>
                </div>
                <div className="w-full flex justify-between items-center mt-2">
                  <div className="flex items-center gap-4 ">
                    <img
                      src={greaterThanIcon}
                      className={`w-8 h-8 transform transition-transform ${expandedRow === index ? 'rotate-90' : ''}`}
                      alt="toggle"
                      onClick={() => handleRowClick(index)}
                    />
                    <p className="text-baseMd -ml-2 text-primary-black truncate">
                      {truncateText(item.fromTown, 10)}
                    </p>
                    <div className="flex font-semibold items-center justify-center">
                      <ViceversaArrow color="#79747E" />
                    </div>
                    <p className="text-baseMd text-primary-black truncate">
                      {truncateText(item.toTown, 10)}
                    </p>
                  </div>
                  <div className="lg:text-right lg:col-span-1 mr-2">
                    <p className="text-baseSm font-medium">
                      <span>₹</span> {item.tadaTotal}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4 ml-2">
                  <p className="text-lightGray text-baseSm font-medium">
                    {item.stationType}
                  </p>
                  <p
                    className="text-primary text-baseSm font-semibold ml-auto mr-2"
                    style={{ color: '#2FC23D' }}
                  >
                    Total Submitted:{' '}
                    <span className="text-lightGray">
                      <span>₹</span> {item.totalSubmitted}
                    </span>
                  </p>
                </div>
              </div>

              {index < details.length - 1 && (
                <hr className="border-t border-gray-300" />
              )}

              {/* Expanded Row */}
              {expandedRow === index && (
                <>
                  <div className="grid grid-cols-2 gap-2 p-2">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Hotel Bills
                        </div>
                        <div className="flex flex-col items-center justify-center ">
                          {item?.uploadTypeDto.length > 0 ? (
                            item?.uploadTypeDto?.map((fare) => {
                              return (
                                <div>
                                  {fare?.billTypeCode === 'HB' ? (
                                    <div
                                      className="underline text-[#A04D95] cursor-pointer text-baseSm"
                                      onClick={() => {
                                        setPreviewUrl(fare?.fileUrl);
                                      }}
                                    >
                                      View
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })
                          ) : (
                            <div>{'-'}</div>
                          )}
                        </div>
                      </div>
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Other Bills
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          {item?.uploadTypeDto.length > 0 ? (
                            item?.uploadTypeDto?.map((fare) => {
                              return (
                                <div>
                                  {fare?.billTypeCode === 'OB' ? (
                                    <div
                                      className="underline text-[#A04D95] cursor-pointer text-baseSm"
                                      onClick={() => {
                                        setPreviewUrl(fare?.fileUrl);
                                      }}
                                    >
                                      View
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })
                          ) : (
                            <div>{'-'}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Fare Bills
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          {item?.uploadTypeDto.length > 0 ? (
                            item?.uploadTypeDto?.map((fare) => {
                              return (
                                <div>
                                  {fare?.billTypeCode === 'FB' ? (
                                    <div
                                      className="underline text-[#A04D95] cursor-pointer text-baseSm"
                                      onClick={() => {
                                        setPreviewUrl(fare?.fileUrl);
                                      }}
                                    >
                                      View
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })
                          ) : (
                            <div>{'-'}</div>
                          )}
                        </div>
                      </div>
                      <div className="flex gap-4 ">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Status
                        </div>
                        <div className="flex flex-col gap-2">
                          <label className="flex items-center space-x-1 cursor-pointer text-xs">
                            <input
                              className="accent-primary cursor-pointer"
                              type="radio"
                              value="A"
                              checked={
                                userDetails[item.expenseDetailId]?.status ===
                                  'A' ||
                                !userDetails[item.expenseDetailId]?.status
                              }
                              onChange={(e) =>
                                handleApprovalAndRemarkChange(
                                  e,
                                  item.expenseDetailId,
                                  'status'
                                )
                              }
                              defaultChecked
                            />
                            <span>Approve</span>
                          </label>
                          <label className="flex items-center space-x-1 cursor-pointer text-xs">
                            <input
                              className="accent-primary cursor-pointer"
                              type="radio"
                              value="R"
                              checked={
                                userDetails[item.expenseDetailId]?.status ===
                                'R'
                              }
                              onChange={(e) =>
                                handleApprovalAndRemarkChange(
                                  e,
                                  item.expenseDetailId,
                                  'status'
                                )
                              }
                            />
                            <span>Reject</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {Number(managerLevelId) === Number(data[0]?.level_id) ? <div className="gap-2 mt-2 grid grid-cols-2 px-2">
                    <p className="text-[#514D4C] font-medium no-whitespace">
                      Oth Exp(₹)Adj
                    </p>
                     <input
                        type="text"
                        className="w-full p h-10 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                        value={item?.staticOtherExpenseTotal ?? ''}
                        onChange={(e) => {
                          handleCalculationChange(
                            index,
                            'staticOtherExpenseTotal',
                            e?.target?.value
                          );
                        }}
                        name="otherExpense"
                      />
                  </div> : null}

                  {Number(managerLevelId) === Number(data[0]?.level_id) ? <div className="gap-2 mt-2 grid grid-cols-2 px-2">
                    <p className="text-[#514D4C] font-medium">
                      Tada Exp(₹)Adj
                    </p>
                    <input
                    type="text"
                    className="w-full  h-10 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                    value={item?.staticTadaTotal ?? ''}
                    onChange={(e) => {
                      handleCalculationChange(
                        index,
                        'staticTadaTotal',
                        e?.target?.value
                      );
                    }}
                    name="staticTadaTotal"
                  />
                  </div> : null}
                  <div className="grid grid-cols-2 gap-2 p-2 bg-[#F3F4F6]">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Activity
                        </div>
                        <div className="text-[#514D4C] font-medium text-baseSm whitespace-nowrap">
                           {item.activity}
                        </div>
                      </div>
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Allowance
                        </div>
                        <div className="text-[#514D4C] font-medium text-baseSm">
                          <span></span>{item.allownace}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd">
                          Distance(KM)
                        </div>
                        <div className="text-[#514D4C] font-medium text-baseSm">{item.distance}KM</div>
                      </div>
                      <div className="flex gap-4 items-center">
                        <div className="text-[#514D4C] font-medium w-24 text-baseMd whitespace-nowrap">
                          Other Ex Total
                        </div>
                        <div className="text-[#514D4C] font-medium text-baseSm">{item?.otherExpenseTotal}</div>
                      </div>
                    </div>
                  </div>
                  <div className="gap-2 mt-2 grid grid-cols-2 px-2">
                    <p className="text-[#514D4C] font-medium text-baseMd">
                      Approval Remarks
                    </p>
                    <textarea
                      className="border border-gray-200 rounded-md p-1 text-xs h-10  focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                      name="remark"
                      value={
                        userDetails[item.expenseDetailId]?.remark === 's'
                          ? ''
                          : userDetails[item.expenseDetailId]?.remark || ''
                      }
                      onChange={(e) =>
                        handleApprovalAndRemarkChange(
                          e,
                          item.expenseDetailId,
                          'remark'
                        )
                      }
                    ></textarea>
                  </div>
                </>
              )}
            </div>
          ))}

        {/* Final Total For Mobile Device */}
        <div className="bg-primary-100 p-2 my-1 pl-4 pr-4 text-[14px] text-center">
          <h2 className="font-semibold text-left ">Grand</h2>
        </div>

        <div className="mt-2 grid grid-cols-2 gap-2 text-baseSm my-1 pl-4 pr-4 text-left">
          <p className="font-medium">Metro Charges </p>
          <p className="text-right font-medium ">
            <span>₹</span> {Array.isArray(details) && details[0]?.metroCharge}
          </p>

          { Number(managerLevelId) === Number(data[0]?.level_id) ? <><p className="font-medium">Metro Charges Adj</p>
          <p className="text-right font-medium ">
            <span>₹</span>{' '}
            <input
              type="text"
              className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
              value={
                (Array.isArray(details) && details[0]?.staticMetroCharge) ?? ''
              }
              onChange={(e) => {
                handleCalculationChange(
                  0,
                  'staticMetroCharge',
                  e?.target?.value
                );
              }}
              name="metroCharges"
            />
          </p></> : null}

          <p className="font-medium">Courier/Photo Copy </p>
          <p className="text-right font-medium">
            <span>₹</span> {Array.isArray(details) && details[0]?.photoCopy}
          </p>

          {Number(managerLevelId) === Number(data[0]?.level_id) ? <><p className="font-medium">Courier/Photo Copy Adj</p>
          <p className="text-right font-medium">
            <span>₹</span>{' '}
            <input
              type="text"
              className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
              value={
                (Array.isArray(details) && details[0]?.staticPhotoCopy) ?? ''
              }
              onChange={(e) => {
                handleCalculationChange(0, 'staticPhotoCopy', e?.target?.value);
              }}
              name="photoCharges"
            />{' '}
          </p></> : null}

          <p className="font-medium">Local Conveyance </p>
          <p className="text-right font-medium">
            <span>₹</span> {Array.isArray(details) && details[0]?.localConveyance}
          </p>

          {Number(managerLevelId) === Number(data[0]?.level_id) ? <><p className="font-medium">Local Conveyance Adj</p>
          <p className="text-right font-medium">
            <span>₹</span>{' '}
            <input
              type="text"
              className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
              value={
                (Array.isArray(details) && details[0]?.staticLocalConveyance) ?? ''
              }
              onChange={(e) => {
                handleCalculationChange(0, 'staticLocalConveyance', e?.target?.value);
              }}
              name="localConveyanceCharges"
            />{' '}
          </p></> : null}

          <p className="font-medium">Fare </p>
          <p className="text-right font-medium">
            <span>₹</span>{' '}
            {Array.isArray(details) &&
              details?.reduce((a, c) => {
                return a + c?.fare;
              }, 0)}
          </p>

          <p className="font-medium">Allowance </p>
          <p className="text-right font-medium">
            <span>₹</span>{' '}
            {Array.isArray(details) &&
              details?.reduce((a, c) => {
                return a + c?.allownace;
              }, 0)}
          </p>

          <p className="font-medium">Tada Exp </p>
          <p className="text-right font-medium">
            <span>₹</span>{' '}
            {Array.isArray(details) &&
              details?.reduce((a, c) => a + (c?.staticTadaTotal ?? 0), 0)}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-evenly items-start sm:items-center bg-[#F7F0FF] rounded-md mx-4 mt-4 p-4 gap-3 sm:gap-0 divide-y divide-[#E0D9F0] sm:divide-y-0 m-4">
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0 first:pt-0">
            <div className="text-[#514D4C] font-medium">Expense Total</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce((a, c) => a + (c?.staticTadaTotal ?? 0), 0)}
            </div>
          </div>
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Other Expense</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) => a + (c?.staticOtherExpenseTotal ?? 0),
                  0
                )}
            </div>
          </div>
          <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Grand Total</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) =>
                    a + (c?.tadaTotal ?? 0) + (c?.otherExpenseTotal ?? 0),
                  0
                ) +
                  Number(details[0]?.metroCharge) +
                  Number(details[0]?.photoCopy) +
                  Number(details[0]?.localConveyance)}
            </div>
          </div>
         {Number(managerLevelId) === Number(data[0]?.level_id) ?  <div className="flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0">
            <div className="text-[#514D4C] font-medium">Grand Total Adj</div>
            <div>
              <span>₹</span>
              {Array.isArray(details) &&
                details?.reduce(
                  (a, c) =>
                    a +
                    (c?.staticTadaTotal ?? 0) +
                    (c?.staticOtherExpenseTotal ?? 0),
                  0
                ) +
                  Number(details[0]?.staticMetroCharge) +
                  Number(details[0]?.staticPhotoCopy)}
            </div>
          </div> : null}
        </div>
      </div>
    </div>
  );
};

export default ApprovalDetails;
